'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.USER_LOGIN_ERROR = exports.USER_LOGOUT = exports.USER_SET = exports.USER_LOGIN = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

exports.userLoginError = userLoginError;
exports.userLogin = userLogin;
exports.userRegister = userRegister;
exports.userPasswordResetRequest = userPasswordResetRequest;
exports.userPasswordReset = userPasswordReset;
exports.fetchUserIfNeeded = fetchUserIfNeeded;
exports.userLogout = userLogout;

var _bdcoreUtilities = require('@bd/bdcore-utilities');

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var USER_LOGIN = exports.USER_LOGIN = 'USER_LOGIN';
var USER_SET = exports.USER_SET = 'USER_SET';
var USER_LOGOUT = exports.USER_LOGOUT = 'USER_LOGOUT';
var USER_LOGIN_ERROR = exports.USER_LOGIN_ERROR = 'USER_LOGIN_ERROR';

var API_URL = 'https://api.mybuildercloud.com/api/v2/users';

function userLoginError(message) {
  return {
    type: USER_LOGIN_ERROR,
    message: message
  };
}

function userLogin(email, password) {
  var _this = this;

  return function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch) {
      var builderId, _ref2, _ref2$data, user, token;

      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              builderId = _bdcoreUtilities.ConfigStore.getConfig('builder_id');
              _context.prev = 1;
              _context.next = 4;
              return (0, _axios2.default)({
                headers: {},
                url: _bdcoreUtilities.ConfigStore.getConfig('apis.users', API_URL) + '/login',
                method: 'POST',
                data: {
                  builder: builderId,
                  email: email,
                  password: password
                }
              });

            case 4:
              _ref2 = _context.sent;
              _ref2$data = _ref2.data;
              user = _ref2$data.user;
              token = _ref2$data.token;


              dispatch({
                type: USER_LOGIN,
                user: user,
                token: token
              });
              _context.next = 14;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context['catch'](1);

              dispatch(userLoginError(_context.t0.error || _context.t0.message));

            case 14:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[1, 11]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}

function userRegister(newUser) {
  var _this2 = this;

  return function () {
    var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch) {
      var builderId, _ref4, _ref4$data, user, token;

      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              builderId = _bdcoreUtilities.ConfigStore.getConfig('builder_id');
              _context2.prev = 1;
              _context2.next = 4;
              return (0, _axios2.default)({
                headers: {},
                url: _bdcoreUtilities.ConfigStore.getConfig('apis.users', API_URL) + '/register',
                method: 'POST',
                data: (0, _extends3.default)({}, newUser, {
                  builder: builderId
                })
              });

            case 4:
              _ref4 = _context2.sent;
              _ref4$data = _ref4.data;
              user = _ref4$data.user;
              token = _ref4$data.token;


              dispatch({
                type: USER_LOGIN,
                user: user,
                token: token
              });
              _context2.next = 14;
              break;

            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2['catch'](1);

              dispatch(userLoginError(_context2.t0.error || _context2.t0.message));

            case 14:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[1, 11]]);
    }));

    return function (_x2) {
      return _ref3.apply(this, arguments);
    };
  }();
}

function userPasswordResetRequest(email, returnUrl) {
  var _this3 = this;

  return function () {
    var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(dispatch, getState) {
      var builderId, builderName;
      return _regenerator2.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              builderId = _bdcoreUtilities.ConfigStore.getConfig('builder_id');
              builderName = (0, _lodash.get)(getState(), 'cloudData.builder.' + builderId + '.data.name');
              _context3.prev = 2;
              _context3.next = 5;
              return (0, _axios2.default)({
                headers: {},
                url: _bdcoreUtilities.ConfigStore.getConfig('apis.users', API_URL) + '/password-reset/request',
                method: 'POST',
                data: {
                  email: email,
                  builder: builderId,
                  reset_url: returnUrl,
                  builder_name: builderName
                }
              });

            case 5:
              _context3.next = 10;
              break;

            case 7:
              _context3.prev = 7;
              _context3.t0 = _context3['catch'](2);

              dispatch(userLoginError(_context3.t0.error || _context3.t0.message));

            case 10:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3, [[2, 7]]);
    }));

    return function (_x3, _x4) {
      return _ref5.apply(this, arguments);
    };
  }();
}

function userPasswordReset(password, resetToken) {
  var _this4 = this;

  var builderId = _bdcoreUtilities.ConfigStore.getConfig('builder_id');

  return function () {
    var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(dispatch) {
      var _ref7, _ref7$data, user, token;

      return _regenerator2.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return (0, _axios2.default)({
                headers: {
                  Authorization: 'Bearer ' + resetToken
                },
                url: _bdcoreUtilities.ConfigStore.getConfig('apis.users', API_URL) + '/password-reset',
                method: 'POST',
                data: {
                  password: password,
                  builder: builderId
                }
              });

            case 3:
              _ref7 = _context4.sent;
              _ref7$data = _ref7.data;
              user = _ref7$data.user;
              token = _ref7$data.token;


              dispatch({
                type: USER_LOGIN,
                user: user,
                token: token
              });
              _context4.next = 13;
              break;

            case 10:
              _context4.prev = 10;
              _context4.t0 = _context4['catch'](0);

              dispatch(userLoginError(_context4.t0.error || _context4.t0.message));

            case 13:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4, [[0, 10]]);
    }));

    return function (_x5) {
      return _ref6.apply(this, arguments);
    };
  }();
}

function fetchUser(state) {
  var _this5 = this;

  return function () {
    var _ref8 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(dispatch) {
      var token, _ref9, user;

      return _regenerator2.default.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              token = (0, _lodash.get)(state, 'user.token');
              _context5.prev = 1;
              _context5.next = 4;
              return (0, _axios2.default)({
                headers: {
                  Authorization: 'Bearer ' + token
                },
                url: _bdcoreUtilities.ConfigStore.getConfig('apis.users', API_URL) + '/user',
                method: 'GET'
              });

            case 4:
              _ref9 = _context5.sent;
              user = _ref9.data.user;


              dispatch({
                type: USER_SET,
                user: user
              });
              _context5.next = 13;
              break;

            case 9:
              _context5.prev = 9;
              _context5.t0 = _context5['catch'](1);

              dispatch({
                type: USER_LOGOUT
              });
              dispatch(userLoginError(_context5.t0.error || _context5.t0.message));

            case 13:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5, [[1, 9]]);
    }));

    return function (_x6) {
      return _ref8.apply(this, arguments);
    };
  }();
}

function shouldFetchUser(_ref10) {
  var _ref10$user = _ref10.user,
      user = _ref10$user === undefined ? {} : _ref10$user;

  if (!user.user && user.token) {
    return true;
  }

  return false;
}

function fetchUserIfNeeded() {
  return function (dispatch, getState) {
    if (shouldFetchUser(getState())) {
      return dispatch(fetchUser(getState()));
    }
    return null;
  };
}

function userLogout() {
  return {
    type: USER_LOGOUT
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-data/build/User/actions.js
// module id = 124
// module chunks = 0